import $axiosProtected from "../../../../common/utils/axiosUtils";

export const addBill = async (payload: any) => {
    return await $axiosProtected().post(
        `/inventory/salesOrder/store/web`,
        payload
    );
};
